import React from 'react'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import { useValue } from '@morningtrain/react-resources'
import { useEnvValue } from '@morningtrain/react-helpers'
import moment from 'moment'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'

export default function HistoricalChecklistSummary () {
  const listCount = useValue('lists')
  const missedListCount = useValue('missed')
  const date = useValue('key')

  const dotColor = missedListCount > 0 ? 'red' : 'green'

  const [, setPeriod] = useEnvValue('checklist.filter.period', null)

  const updatePeriod = () => {
    setPeriod(moment(date).endOf('day').toDate())
  }

  return (
    <SmartviewText
      onClick={updatePeriod}
      className='cursor-pointer'
      label={(
        <UI.StatusText color={dotColor}>
          <UI.Text weight='medium'>
            <Displays.Date name='key'/>
          </UI.Text>
        </UI.StatusText>
      )}
    >
      <Translation
        name='checklists.historic.list_count'
        data={{
          total: listCount,
          missed: missedListCount
        }}
      />
    </SmartviewText>
  )
}
